import { v4 } from '@lukeed/uuid';
export async function appendArrayBuffer(fileCollection, relativePath, arrayBuffer, options = {}) {
    const source = await getExtendedSourceFromArrayBuffer(relativePath, arrayBuffer, options);
    await fileCollection.appendExtendedSource(source);
}
async function getExtendedSourceFromArrayBuffer(relativePath, arrayBuffer, options = {}) {
    const blob = new Blob([await arrayBuffer], {
        type: 'application/octet-stream',
    });
    return {
        uuid: v4(),
        relativePath,
        name: relativePath.split('/').pop(),
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        text: () => blob.text(),
        stream: () => blob.stream(),
        arrayBuffer: () => blob.arrayBuffer(),
    };
}
//# sourceMappingURL=appendArrayBuffer.js.map